import variableColors from "@/base/global/variables/figma.colors.json";
import variableTypography from "@/base/global/variables/figma.typography.json";
import variableEffects from "@/base/global/variables/figma.effects.json";

export const cardThemeToken: any = {
  borderRadiusLG: 4,
  boxShadowCard: variableEffects["BoxShadowElevation2"],
  boxShadowTertiary: variableEffects["BoxShadowElevation2"],

  //========================= COLOR =================================/
  colorTextDescription: variableColors["ColorFigmaNeutralGrayscaleGray70"],
  colorText: variableColors["ColorFigmaNeutralGrayscaleGray90"],
  colorTextHeading: variableColors["ColorFigmaNeutralGrayscaleGray90"],
  colorPrimary: variableColors["ColorFigmaComplementaryBlue50"],

  fontHeight: variableTypography["BodyMediumLineHeight"],
  fontSize: variableTypography["BodyMediumFontSize"],
  fontSizeLG: variableTypography["BodyLargeFontSize"],
};
